import React, { useState, useEffect } from "react";
import { FaHeart, FaShoppingCart } from "react-icons/fa";
import { useSelector, useDispatch } from "react-redux";

import {
  Container,
  CTAButton,
  HeaderContainer,
  HeaderContent,
  Logo,
  Nav,
  NavLink,
  CartIcon,
  CartBadge,
  HeaderActions,
  CartIconStyled,
  HeaderContainerStyled,
} from "./Header.styles";
import { useLocation, useNavigate } from "react-router-dom";
import { selectCartTotalItems } from "../../store/slices/cart/slice";
import { loadCart } from "../../store/slices/cart/asyncThunks";
import LogoImg from "../../assets/images/logo-01.png";
import LogoImgWhite from "../../assets/images/logo-03.png";
import AnimatedMenuIcon from "../utils/AnimatedMenuIcon";
import MobileMenu from "../utils/MobileMenu/MobileMenu";

const Header = ({ tickerVisible = false }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);

  const [cartPulse, setCartPulse] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  // Get cart count from Redux
  const cartCount = useSelector(selectCartTotalItems);

  const toggleMobileMenu = () => {
    setShowMobileMenu(!showMobileMenu);
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Load cart on component mount
  useEffect(() => {
    dispatch(loadCart());
  }, [dispatch]);

  const onNavigate = (path) => {
    navigate(path);
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 300);
  };

  const handleCartClick = () => {
    onNavigate("/korpa");
  };

  // Effect to trigger cart badge pulse animation when count changes
  useEffect(() => {
    if (cartCount > 0) {
      setCartPulse(true);
      const timer = setTimeout(() => setCartPulse(false), 600);
      return () => clearTimeout(timer);
    }
  }, [cartCount]);

  return (
    <>
      {pathname === "/" ? (
        <HeaderContainer
          className={isScrolled || showMobileMenu ? "scrolled" : ""}
          $tickerVisible={tickerVisible}
        >
          <Container>
            <HeaderContent>
              <div style={{ cursor: "pointer" }}>
                <Logo
                  src={isScrolled || showMobileMenu ? LogoImg : LogoImgWhite}
                  alt="MITOVKA BeautySpot logo"
                />
              </div>
              <Nav>
                <ul>
                  <li>
                    <NavLink
                      className={isScrolled || showMobileMenu ? "scrolled" : ""}
                      $active={pathname === "/galerija"}
                      onClick={() => {
                        onNavigate("/galerija");
                      }}
                    >
                      Galerija
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      $active={pathname === "/kursevi"}
                      className={isScrolled || showMobileMenu ? "scrolled" : ""}
                      onClick={() => {
                        onNavigate("/kursevi");
                      }}
                    >
                      Kursevi
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      $active={pathname === "/o-meni"}
                      className={isScrolled || showMobileMenu ? "scrolled" : ""}
                      onClick={() => {
                        onNavigate("/o-meni");
                      }}
                    >
                      O Meni
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      $active={pathname === "/cesta-pitanja"}
                      className={isScrolled || showMobileMenu ? "scrolled" : ""}
                      onClick={() => {
                        onNavigate("/cesta-pitanja");
                      }}
                    >
                      FAQ
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      $active={pathname === "/kontakt"}
                      className={isScrolled || showMobileMenu ? "scrolled" : ""}
                      onClick={() => {
                        onNavigate("/kontakt");
                      }}
                    >
                      Kontakt
                    </NavLink>
                  </li>
                </ul>
              </Nav>

              <HeaderActions>
                <CartIcon
                  onClick={handleCartClick}
                  className={isScrolled || showMobileMenu ? "scrolled" : ""}
                >
                  <FaShoppingCart />
                  {cartCount > 0 && (
                    <CartBadge
                      $pulse={cartPulse}
                      className={isScrolled || showMobileMenu ? "scrolled" : ""}
                    >
                      {cartCount > 99 ? "99+" : cartCount}
                    </CartBadge>
                  )}
                </CartIcon>

                <CTAButton
                  className={isScrolled || showMobileMenu ? "scrolled" : ""}
                  onClick={() => {
                    onNavigate("/pristup");
                  }}
                >
                  <FaHeart />
                  Počni Učenje
                </CTAButton>
              </HeaderActions>
              <AnimatedMenuIcon
                onClick={toggleMobileMenu}
                isOpen={showMobileMenu}
                color={
                  isScrolled || showMobileMenu
                    ? "var(--accent)"
                    : "var(--surface)"
                }
              />
            </HeaderContent>
          </Container>
        </HeaderContainer>
      ) : (
        <HeaderContainerStyled
          className="scrolled"
          $tickerVisible={tickerVisible}
        >
          <Container>
            <HeaderContent>
              <div
                style={{ cursor: "pointer" }}
                onClick={() => {
                  onNavigate("/");
                }}
              >
                <Logo src={LogoImg} alt="MITOVKA BeautySpot logo" />
              </div>
              <Nav>
                <ul>
                  <li>
                    <NavLink
                      className="scrolled"
                      $active={pathname === "/galerija"}
                      onClick={() => {
                        onNavigate("/galerija");
                      }}
                    >
                      Galerija
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className="scrolled"
                      $active={pathname === "/kursevi"}
                      onClick={() => {
                        onNavigate("/kursevi");
                      }}
                    >
                      Kursevi
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      $active={pathname === "/o-meni"}
                      className="scrolled"
                      onClick={() => {
                        onNavigate("/o-meni");
                      }}
                    >
                      O Meni
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      $active={pathname === "/cesta-pitanja"}
                      className="scrolled"
                      onClick={() => {
                        onNavigate("/cesta-pitanja");
                      }}
                    >
                      FAQ
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      $active={pathname === "/kontakt"}
                      className="scrolled"
                      onClick={() => {
                        onNavigate("/kontakt");
                      }}
                    >
                      Kontakt
                    </NavLink>
                  </li>
                </ul>
              </Nav>

              <HeaderActions>
                <CartIconStyled onClick={handleCartClick}>
                  <FaShoppingCart />
                  {cartCount > 0 && (
                    <CartBadge $pulse={cartPulse} className="scrolled">
                      {cartCount > 99 ? "99+" : cartCount}
                    </CartBadge>
                  )}
                </CartIconStyled>

                <CTAButton
                  onClick={() => {
                    onNavigate("/pristup");
                  }}
                >
                  <FaHeart />
                  Počni Učenje
                </CTAButton>
              </HeaderActions>
              <AnimatedMenuIcon
                onClick={toggleMobileMenu}
                isOpen={showMobileMenu}
              />
            </HeaderContent>
          </Container>
        </HeaderContainerStyled>
      )}

      {/* MOBILNI MENI MODAL */}
      <MobileMenu
        isOpen={showMobileMenu}
        onClose={() => setShowMobileMenu(false)}
        onNavigate={onNavigate}
        tickerVisible={tickerVisible}
      />
    </>
  );
};

export default Header;
